import './delete-rows-select.scss';

import { useEffect, useState } from 'react';

import useResize from '@/shared/hooks/useResize';
import { Button } from '@/shared/ui';

export interface IRowsToDelete<Type, Data> {
  type: Type;
  data: Data[];
  rowKeys: React.Key[];
}

interface IProps {
  tableTitle: string;
  selectedRowsCount: number;
  onDeleteChosen: () => void;
  onDeleteAll: () => void;
  onReset: () => void;
}

const DeleteRowsSelectAdmin: React.FC<IProps> = ({
  tableTitle,
  selectedRowsCount,
  onDeleteChosen,
  onDeleteAll,
  onReset
}) => {
  const [navbar, setNavbar] = useState<HTMLElement | null>(null);
  const [navbarWidth] = useResize({ element: navbar });

  const isShown = selectedRowsCount > 0;

  const popupClass = [
    'delete-rows-select__popup',
    isShown ? 'delete-rows-select__popup--shown' : ''
  ].join(' ');

  const heightSimulateClass = [
    'delete-rows-select__height-simulate',
    isShown ? 'delete-rows-select__height-simulate--shown' : ''
  ].join(' ');

  useEffect(() => {
    const navbar = document.querySelector('aside.navbar') as HTMLElement;
    setNavbar(navbar);
  }, []);

  return (
    <>
      <div className={heightSimulateClass}></div>
      <div style={{ left: `${navbarWidth}px` }} className={popupClass}>
        <div className="delete-rows-select__content">
          {tableTitle} выбрано: {selectedRowsCount}
          <div className="delete-rows-select__actions">
            <Button
              type="button"
              size="small"
              variant="filled-blue"
              onClick={onDeleteChosen}
            >
              Удалить выбранные
            </Button>
            <Button
              type="button"
              size="small"
              variant="filled-blue"
              onClick={onDeleteAll}
            >
              Удалить все
            </Button>
            <Button
              type="button"
              className="delete-rows-select__reset"
              size="small"
              onClick={onReset}
            >
              Сбросить
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteRowsSelectAdmin;
